/* BAETTAGE custom theme interactions */
(function(){
  'use strict';

  function defaultTo(a,b){ return (a===null||a===undefined||a==='') ? b : a; }
  function formatWithDelimiters(number, precision, thousands, decimalSep){
    precision = defaultTo(precision,2); thousands = defaultTo(thousands,','); decimalSep = defaultTo(decimalSep,'.');
    if(isNaN(number) || number == null) number = 0;
    number = (number/100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+thousands);
    var cents = parts[1] ? decimalSep+parts[1] : '';
    return dollars+cents;
  }
  function formatMoney(cents, format){
    format = format || window.themeMoneyFormat || '€{{amount}}';
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if(!match){ return format; }
    switch(match[1]){
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }
  window.BTFormatMoney = formatMoney;

  /* ---------- Image fade-in ---------- */
  function initImageFade(root){
    (root || document).querySelectorAll('.bt-img-lazy').forEach(function(img){
      if(img.classList.contains('is-loaded')) return;
      if(img.complete && img.naturalWidth > 0){ img.classList.add('is-loaded'); }
      else { img.addEventListener('load', function(){ img.classList.add('is-loaded'); }); }
    });
  }
  window.BTInitImageFade = initImageFade;

  /* ---------- Scroll reveal ---------- */
  function initReveal(){
    var els = document.querySelectorAll('[data-animate]');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var el = entry.target;
          var delay = el.getAttribute('data-animate-delay') || 0;
          setTimeout(function(){ el.classList.add('is-visible'); }, delay);
          io.unobserve(el);
        }
      });
    }, {threshold:.12, rootMargin:'0px 0px -60px 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- Header sticky shadow + mobile nav ---------- */
  function initHeader(){
    var header = document.querySelector('.bt-header');
    if(header){
      function onScroll(){
        if(window.scrollY > 8){ header.classList.add('is-stuck'); } else { header.classList.remove('is-stuck'); }
      }
      document.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }

    var burger = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if(burger && nav){
      function close(){ nav.classList.remove('is-open'); burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
      burger.addEventListener('click', function(){
        var open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true':'false');
        document.body.style.overflow = open ? 'hidden':'';
      });
      var backdrop = nav.querySelector('[data-mobile-nav-backdrop]');
      if(backdrop) backdrop.addEventListener('click', close);
      var closeBtn = nav.querySelector('[data-mobile-nav-close]');
      if(closeBtn) closeBtn.addEventListener('click', close);
    }
  }

  function initHero(){
    document.querySelectorAll('.bt-hero').forEach(function(h){
      requestAnimationFrame(function(){ h.classList.add('is-visible'); });
    });
  }

  /* ---------- Toast ---------- */
  function showToast(message){
    var toast = document.querySelector('[data-toast]');
    if(!toast){
      toast = document.createElement('div');
      toast.className = 'bt-toast';
      toast.setAttribute('data-toast', '');
      toast.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg><span data-toast-text></span>';
      document.body.appendChild(toast);
    }
    toast.querySelector('[data-toast-text]').textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function(){ toast.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- Button success morph ---------- */
  function flashSuccess(btn, duration){
    if(!btn) return;
    if(!btn.querySelector('.bt-btn__check')){
      var check = document.createElement('span');
      check.className = 'bt-btn__check';
      check.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      btn.appendChild(check);
    }
    var label = btn.querySelector('.bt-btn__label, [data-btn-label]');
    if(label) label.classList.add('bt-btn__label');
    btn.classList.add('is-added');
    setTimeout(function(){ btn.classList.remove('is-added'); }, duration || 1400);
  }

  /* ---------- Cart icon bump ---------- */
  function bumpCartIcon(){
    document.querySelectorAll('[data-cart-open]').forEach(function(btn){
      btn.classList.remove('is-bump');
      void btn.offsetWidth;
      btn.classList.add('is-bump');
      setTimeout(function(){ btn.classList.remove('is-bump'); }, 500);
    });
  }

  /* ================= CART ================= */
  var Cart = {
    drawer: null,
    init: function(){
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.bindOpenTriggers();
      this.bindDrawerControls();
      this.bindAddToCartForms();
      this.bindQuickAdd();
      this.refresh();
    },
    bindOpenTriggers: function(){
      var self = this;
      document.querySelectorAll('[data-cart-open]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          if(btn.tagName === 'A') e.preventDefault();
          self.open();
        });
      });
    },
    bindDrawerControls: function(){
      var self = this;
      if(!this.drawer) return;
      var backdrop = this.drawer.querySelector('[data-cart-backdrop]');
      var closeBtn = this.drawer.querySelector('[data-cart-close]');
      if(backdrop) backdrop.addEventListener('click', function(){ self.close(); });
      if(closeBtn) closeBtn.addEventListener('click', function(){ self.close(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') self.close(); });
      this.drawer.addEventListener('click', function(e){
        var removeBtn = e.target.closest('[data-cart-remove]');
        if(removeBtn){ e.preventDefault(); self.changeLine(removeBtn.getAttribute('data-cart-remove'), 0); }
        var qtyBtn = e.target.closest('[data-cart-qty]');
        if(qtyBtn){
          e.preventDefault();
          var key = qtyBtn.getAttribute('data-key');
          var dir = qtyBtn.getAttribute('data-cart-qty');
          var input = self.drawer.querySelector('input[data-qty-input="'+key+'"]');
          var current = input ? parseInt(input.value,10) : 1;
          var next = dir === 'plus' ? current+1 : Math.max(0,current-1);
          self.changeLine(key, next);
        }
      });
    },
    open: function(){ if(this.drawer){ this.drawer.classList.add('is-open'); document.body.style.overflow='hidden'; } },
    close: function(){ if(this.drawer){ this.drawer.classList.remove('is-open'); document.body.style.overflow=''; } },
    bindAddToCartForms: function(){
      var self = this;
      document.querySelectorAll('[data-cart-add-form]').forEach(function(form){
        form.addEventListener('submit', function(e){
          e.preventDefault();
          var btn = form.querySelector('[type="submit"]');
          if(btn) btn.classList.add('bt-btn--loading');
          fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify(self.serialize(form))
          }).then(function(r){ return r.json(); }).then(function(data){
            if(btn) btn.classList.remove('bt-btn--loading');
            if(data.status){ self.showError(data.description || 'Could not add to cart'); return; }
            flashSuccess(btn);
            self.refresh().then(function(){ bumpCartIcon(); setTimeout(function(){ self.open(); }, 280); });
          }).catch(function(){ if(btn) btn.classList.remove('bt-btn--loading'); });
        });
      });
      var stickyAdd = document.querySelector('[data-sticky-add]');
      if(stickyAdd){
        stickyAdd.addEventListener('click', function(){
          var mainForm = document.querySelector('[data-cart-add-form]');
          if(mainForm){ mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.dispatchEvent(new Event('submit', {cancelable:true})); }
        });
      }
    },
    bindQuickAdd: function(){
      var self = this;
      document.addEventListener('click', function(e){
        var btn = e.target.closest('[data-quick-add]');
        if(!btn) return;
        e.preventDefault();
        if(btn.classList.contains('is-loading')) return;
        var variantId = btn.getAttribute('data-variant-id');
        if(!variantId) return;
        var originalText = btn.textContent;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function(r){ return r.json(); }).then(function(data){
          btn.classList.remove('is-loading');
          if(data.status){ self.showError(data.description || 'Could not add to cart'); return; }
          btn.classList.add('is-added');
          btn.textContent = 'Added';
          showToast('Added to bag');
          self.refresh().then(function(){ bumpCartIcon(); });
          setTimeout(function(){ btn.classList.remove('is-added'); btn.textContent = originalText; }, 1600);
        }).catch(function(){ btn.classList.remove('is-loading'); });
      });
    },
    serialize: function(form){
      var fd = new FormData(form);
      var obj = {};
      fd.forEach(function(v,k){
        if(k === 'id'){ obj.id = v; }
        else if(k === 'quantity'){ obj.quantity = parseInt(v,10) || 1; }
        else { obj[k] = v; }
      });
      return obj;
    },
    changeLine: function(key, quantity){
      var self = this;
      fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id:key, quantity:quantity})
      }).then(function(r){ return r.json(); }).then(function(cart){ self.render(cart); });
    },
    showError: function(msg){
      var el = document.querySelector('[data-cart-error]');
      if(el){ el.textContent = msg; el.hidden = false; setTimeout(function(){ el.hidden = true; }, 4000); }
      else { showToast(msg); }
    },
    refresh: function(){
      var self = this;
      return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ self.render(cart); return cart; });
    },
    render: function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
      if(!this.drawer) return;
      var itemsEl = this.drawer.querySelector('[data-cart-items]');
      var subtotalEl = this.drawer.querySelector('[data-cart-subtotal]');
      var emptyEl = this.drawer.querySelector('[data-cart-empty]');
      var footerEl = this.drawer.querySelector('[data-cart-footer]');
      if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if(cart.item_count === 0){
        if(itemsEl) itemsEl.innerHTML = '';
        if(emptyEl) emptyEl.hidden = false;
        if(footerEl) footerEl.hidden = true;
        return;
      }
      if(emptyEl) emptyEl.hidden = true;
      if(footerEl) footerEl.hidden = false;
      if(!itemsEl) return;
      var html = cart.items.map(function(item){
        return '<div class="bt-cart-line">'+
          '<a href="'+item.url+'" class="bt-cart-line__media"><img src="'+(item.image ? item.image.replace('{width}','200') : '')+'" alt="" loading="lazy"></a>'+
          '<div class="bt-cart-line__body">'+
            '<a href="'+item.url+'" class="bt-cart-line__title">'+item.product_title+'</a>'+
            (item.variant_title ? '<div class="bt-cart-line__variant">'+item.variant_title+'</div>' : '')+
            '<div class="bt-cart-line__row">'+
              '<div class="bt-qty">'+
                '<button type="button" data-cart-qty="minus" data-key="'+item.key+'" aria-label="Decrease quantity">−</button>'+
                '<input type="text" readonly value="'+item.quantity+'" data-qty-input="'+item.key+'">'+
                '<button type="button" data-cart-qty="plus" data-key="'+item.key+'" aria-label="Increase quantity">+</button>'+
              '</div>'+
              '<span>'+formatMoney(item.final_line_price)+'</span>'+
            '</div>'+
            '<button type="button" class="bt-cart-line__remove" data-cart-remove="'+item.key+'">Remove</button>'+
          '</div>'+
        '</div>';
      }).join('');
      itemsEl.innerHTML = html;
    }
  };

  /* ================= PRODUCT PAGE ================= */
  function initProduct(){
    var root = document.querySelector('[data-product-root]');
    if(!root) return;
    var dataEl = root.querySelector('[data-product-json]');
    if(!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch(e){ return; }

    var mainImgs = root.querySelectorAll('[data-gallery-image]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var pills = root.querySelectorAll('[data-option-value]');
    var priceEls = document.querySelectorAll('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var saveEl = root.querySelector('[data-save]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-btn]');
    var stockEl = root.querySelector('[data-stock]');
    var selectedOptions = {};

    root.querySelectorAll('[data-option-index]').forEach(function(group){
      if(!group.hasAttribute('data-option-value')){
        var idx = group.getAttribute('data-option-index');
        var selected = group.querySelector('.is-selected');
        if(selected) selectedOptions[idx] = selected.getAttribute('data-option-value');
      }
    });

    thumbs.forEach(function(thumb, i){
      thumb.addEventListener('click', function(){
        thumbs.forEach(function(t){ t.classList.remove('is-active'); });
        mainImgs.forEach(function(m){ m.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if(mainImgs[i]) mainImgs[i].classList.add('is-active');
      });
    });

    function findVariant(){
      return product.variants.find(function(v){
        return v.options.every(function(opt, i){ return selectedOptions[i] === opt; });
      });
    }

    function updateVariant(){
      var variant = findVariant();
      if(!variant) return;
      if(idInput) idInput.value = variant.id;
      priceEls.forEach(function(el){ el.textContent = formatMoney(variant.price); });
      if(compareEl){
        if(variant.compare_at_price && variant.compare_at_price > variant.price){
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
          if(saveEl){
            var pct = Math.round((1 - variant.price/variant.compare_at_price)*100);
            saveEl.textContent = 'Save ' + pct + '%';
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if(saveEl) saveEl.hidden = true;
        }
      }
      if(addBtn){
        addBtn.disabled = !variant.available;
        var labelSpan = addBtn.querySelector('[data-btn-label]');
        var label = variant.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold-out');
        if(labelSpan) labelSpan.textContent = label;
      }
      if(stockEl){
        stockEl.classList.remove('in','low','out');
        if(!variant.available){
          stockEl.textContent = 'Out of stock';
          stockEl.classList.add('out');
        } else if(typeof variant.inventory_quantity === 'number' && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5){
          stockEl.textContent = 'Only ' + variant.inventory_quantity + ' left in stock';
          stockEl.classList.add('low');
        } else {
          stockEl.textContent = 'In stock, ready to ship';
          stockEl.classList.add('in');
        }
      }
      if(variant.featured_media){
        var idx = product.media.findIndex(function(m){ return m.id === variant.featured_media.id; });
        if(idx > -1 && mainImgs[idx]){
          mainImgs.forEach(function(m){ m.classList.remove('is-active'); });
          thumbs.forEach(function(t){ t.classList.remove('is-active'); });
          mainImgs[idx].classList.add('is-active');
          if(thumbs[idx]) thumbs[idx].classList.add('is-active');
        }
      }
      pills.forEach(function(p){
        var idx = p.getAttribute('data-option-index');
        var val = p.getAttribute('data-option-value');
        var testOptions = Object.assign({}, selectedOptions);
        testOptions[idx] = val;
        var test = product.variants.find(function(v){ return v.options.every(function(o,i){ return testOptions[i] === o; }); });
        p.classList.toggle('is-disabled', !test || !test.available);
      });
    }

    pills.forEach(function(pill){
      pill.addEventListener('click', function(){
        var idx = pill.getAttribute('data-option-index');
        var group = root.querySelector('.bt-option[data-option-index="'+idx+'"]');
        if(group) group.querySelectorAll('[data-option-value]').forEach(function(p){ p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        selectedOptions[idx] = pill.getAttribute('data-option-value');
        updateVariant();
      });
    });

    var qtyWrap = root.querySelector('[data-qty-wrap]');
    if(qtyWrap){
      var qtyInput = qtyWrap.querySelector('input');
      qtyWrap.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){
          var dir = btn.getAttribute('data-step');
          var val = parseInt(qtyInput.value,10) || 1;
          qtyInput.value = dir === 'plus' ? val+1 : Math.max(1,val-1);
        });
      });
    }

    var stickyBar = document.querySelector('[data-sticky-bar]');
    var buyBox = root.querySelector('[data-buybox]');
    if(stickyBar && buyBox && 'IntersectionObserver' in window){
      var stickyObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, {threshold:0});
      stickyObserver.observe(buyBox);
    }

    updateVariant();
  }

  /* ---------- PDP hover zoom ---------- */
  function initPdpZoom(){
    var mainEl = document.querySelector('.bt-gallery__main');
    if(!mainEl) return;
    function move(e){
      if(window.innerWidth < 900) return;
      var rect = mainEl.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      var active = mainEl.querySelector('img.is-active');
      if(active) active.style.transformOrigin = x + '% ' + y + '%';
    }
    mainEl.addEventListener('mousemove', move);
    mainEl.addEventListener('mouseenter', function(){ if(window.innerWidth >= 900) mainEl.classList.add('is-zoomed'); });
    mainEl.addEventListener('mouseleave', function(){
      mainEl.classList.remove('is-zoomed');
      var active = mainEl.querySelector('img.is-active');
      if(active) active.style.transformOrigin = 'center';
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initImageFade();
    initReveal();
    initHeader();
    initHero();
    Cart.init();
    initProduct();
    initPdpZoom();
  });
  window.BTCart = Cart;
})();
